export default function defined(val) {
  return val !== undefined && val !== null;
}
